import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Modal, Button as BButton, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faUserPlus, 
    faDownload,
    faUserShield
} from '@fortawesome/free-solid-svg-icons';
import swal from 'sweetalert';
import { createProfilaction, updateProfilAction, deleteParamAction, getProfilAction, resetSaveDoneAction, startLoader } from '../../../store/actions/UserAction';
import Select from 'react-select';
import { currentUser } from "../../../store/selectors/CurrentUserSelector";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { Calendar } from 'primereact/calendar';
import { DataTableBase } from '../DataTables/DataTableBase';
import { useTranslation } from "react-i18next";

const Profil = (props) => {
    const { t } = useTranslation();
    let errorsObj = { name: '', code: '' };
    
    // Form states
    const [nameFr, setNameFr] = useState('');
    const [nameEn, setNameEn] = useState('');
    const [code, setCode] = useState('');
    const [roles, setRoles] = useState([]);
    const [errors, setErrors] = useState(errorsObj);
    const [id, setId] = useState('');
    const [updateMode, setUpdateMode] = useState(false);
    
    // Modal states
    const [addCard, setAddCard] = useState(false);

    // Filter states
    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            code: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            nameFr: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'roleProfil.role.nameFr': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            createdAt: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
        });
        setGlobalFilterValue("");
    };

    const renderHeader = () => {
        return (
            <div className="d-flex justify-content-between align-items-center">
                <Button 
                    type="button" 
                    icon="pi pi-filter-slash"  
                    label={t('common.reinit')} 
                    outlined 
                    onClick={clearFilter}
                    className="me-2"
                    size="small"
                />
                <div className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText 
                        value={globalFilterValue} 
                        onChange={(e) => onGlobalFilterChange(e)} 
                        placeholder={t('common.search')}
                        size="small"
                    />
                </div>
            </div>
        );
    };

    const clearFilter = () => {
        initFilters();
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const setColumns = () => {
        return [
            {name: 'code', headerName: "Code", filterPlaceholder: 'Filtrer par code', style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
            {name: 'nameFr', headerName: t('common.name'), filterPlaceholder: t('common.filter-name'), style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
            {name: 'roleProfil.role.nameFr', headerName: "Roles", filterPlaceholder: 'Filtrer par roles', style: { minWidth: '12rem' }, filter: true, bodyTemplate: rolesBodyTemplate},
            {name: 'createdAt', filterField: 'createdAt', dataType: 'date', headerName: 'Créé le', filterPlaceholder: t('facturation.create-date-filter'), style: { minWidth: '6rem' }, filter: true, bodyTemplate: datePaiementBodyTemplate, filterElement: dateFilterTemplate},
            {name: 'actions', headerName: 'Actions', filterPlaceholder: '', style: { minWidth: '6rem'}, filter: false, bodyTemplate: getActionsTemplate},
        ]
    };

    const getActionsTemplate = (rowData) => {
        return (
            <div className="d-flex justify-content-center gap-1">
                {hasMenu('MENPARAMUSER') && canDo('MENPARAMUSER', 'UPDATEPROFIL') && (
                    <button 
                        className="btn btn-sm btn-outline-primary"
                        onClick={e => updateAction(rowData)}
                        title={t('common.edit')}
                    >
                        <i className="fa fa-pencil"></i>
                    </button>
                )}
                {hasMenu('MENPARAMUSER') && canDo('MENPARAMUSER', 'DELETEPROFIL') && (
                    <button 
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => handleDelete(rowData)}
                        title={t('common.delete')}
                    >
                        <i className="fa fa-trash"></i>
                    </button>
                )}
            </div>
        );
    };

    const handleDelete = (rowData) => {
        swal({
            title: "Supprimer le profil " + rowData.nameFr + " ?",
            text: "Une fois le profil supprimé, il ne pourra plus être accessible",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                let data = { id: rowData.id };
                props.dispatch(startLoader());
                props.dispatch(deleteParamAction('profil', data));
            }
        });
    };

    const dateFilterTemplate = (options) => {
        return <Calendar 
            value={options.value} 
            onChange={(e) => options.filterCallback(e.value, options.index)} 
            dateFormat="dd/mm/yy" 
            placeholder="dd/mm/yyyy" 
            mask="99/99/9999" 
        />;
    };

    const datePaiementBodyTemplate = (rowData) => {
        return formatDate(rowData.createdAt);
    };

    const rolesBodyTemplate = (rowData) => {
        return rowData.roleProfil?.map((role, index) => {
            return <Tag key={index} value={role.role?.nameFr} severity={'secondary'} className="me-1" />;
        });
    };

    const formatDate = (value) => {
        return value.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    const canDo = (menuCode, actionCode) => {
        let theMenu = props.currentUser.menus?.find(menu => menu.code === menuCode);
        if(!theMenu){
            return false;
        }else{
            return theMenu.actionMenus?.filter(action => action.code === actionCode).length > 0;
        }
    }
    
    const hasMenu = (menuCode) => {
        return props.currentUser.menus?.filter(menu => menu.code === menuCode).length > 0;
    }

    useEffect(() => {
        initFilters();    
    }, []);

    const resetForm = () => {
        setId("");
        setNameFr("");
        setNameEn("");
        setCode("");
        setRoles([]);
        setErrors(errorsObj);
        setUpdateMode(false);
    };

    function onProfilSave(e) {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errorsObj };
        if (code === '') {
            errorObj.code = t('common.code-required');
            error = true;
        }
        if (nameFr === '') {
            errorObj.name = t('common.name-required');
            error = true;
        }
        
        setErrors(errorObj);
        if (error) {
            swal('Oops', t('common.check-form-fields'), "error");
            return;
        }
        
        props.dispatch(startLoader());
        
        let obj = { nameFr: nameFr, nameEn: nameFr, code: code, roles: roles };
        if(updateMode) {
            props.dispatch(updateProfilAction(id, obj));
        }else{
            props.dispatch(createProfilaction(obj));
        }
        
        setAddCard(false);
        resetForm();
    }

    const updateAction = (data) => {
        setId(data.id);
        setNameFr(data.nameFr);
        setNameEn(data.nameEn);
        setCode(data.code);
        setRoles(data.roleProfil ? data.roleProfil.map(res => {return res.role?.id}) : []);
        setUpdateMode(true);
        setAddCard(true);
    }

    useEffect(() => {
        resetForm();
        setAddCard(false);
    }, [props.profils]);

    const newProfilCreate = () => {
        resetForm();
        setAddCard(true);
    }

    const handleDownloadTemplate = () => {
        console.log('Download profil template');
    };

    return (
        <>
            {/* Header */}
            <div className="provider-type-header mb-0 form-head bg-white p-3 bt-5 border-top-solid">
                <div>
                    <h4 className="mb-1">
                        <FontAwesomeIcon icon={faUserShield} className="me-2" />
                        {t('user.profils')}
                    </h4>
                    <p className="text-muted mb-0 small">{t('common.manage-user-profiles')}</p>
                </div>
                <div className="d-flex gap-2">
                    {/* <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={handleDownloadTemplate}
                    >
                        <FontAwesomeIcon icon={faDownload} className="me-1" />
                        {t("common.download-template")}
                    </button> */}
                    
                    {hasMenu('MENPARAMUSER') && canDo('MENPARAMUSER', 'CREATEPROFIL') && (
                        <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={newProfilCreate}
                        >
                            <FontAwesomeIcon icon={faUserPlus} className="me-1" />
                            Nouveau Profil
                        </button>
                    )}
                </div>
            </div>

            {/* Modal for creating/editing profil */}
            <Modal 
                show={addCard} 
                onHide={() => setAddCard(false)}
                centered
                backdrop="static"
            >
                <Modal.Header closeButton className="border-bottom">
                    <Modal.Title className="h5">
                        {!updateMode ? "Créer un nouveau profil" : `Modifier le profil ${nameFr}`}
                    </Modal.Title>
                </Modal.Header>
                
                <Modal.Body className="p-4">
                    <form onSubmit={onProfilSave}>
                        <div className="mb-3">
                            <label className="form-label">{t('common.code')} du profil</label>
                            <input
                                type='text'
                                className={`form-control ${errors.code ? 'is-invalid' : ''}`}
                                placeholder='MD'
                                value={code}
                                disabled={props.showLoading}
                                onChange={(e) => setCode(e.target.value)}
                            />
                            {errors.code && <div className="invalid-feedback">{errors.code}</div>}
                        </div>
                        
                        <div className="mb-3">
                            <label className="form-label">{t('common.label')} Fr</label>
                            <input
                                type='text'
                                className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                placeholder='Médecin'
                                value={nameFr}
                                disabled={props.showLoading}
                                onChange={(e) => setNameFr(e.target.value)}
                            />
                            {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                        </div>
                        
                        <div className="mb-3">
                            <label className="form-label">Roles</label>
                            <Select
                                className="select-search"
                                value={props.rolesData?.filter(elt => roles.includes(elt.roleId)).map(res => ({label: res.roleNameFr, value: res.roleId}))}
                                placeholder="Choisir les roles"
                                onChange={(vals) => setRoles(vals ? vals.map(val => val.value) : [])}
                                disabled={props.showLoading}
                                isMulti
                                options={props.rolesData?.map(res => ({label: res.roleNameFr, value: res.roleId}))}
                            />
                        </div>
                    </form>
                </Modal.Body>
                
                <Modal.Footer className="border-top">
                    <button 
                        type="button" 
                        className="btn btn-outline-secondary"
                        onClick={() => setAddCard(false)}
                        disabled={props.showLoading}
                    >
                        {t('common.cancel')}
                    </button>
                    
                    {props.showLoading ? (
                        <BButton variant="primary" disabled>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            <span className="ms-2">{t('common.saving')}</span>
                        </BButton>
                    ) : (
                        <button 
                            type="submit" 
                            className="btn btn-primary"
                            onClick={onProfilSave}
                        >
                            {t('common.save')}
                        </button>
                    )}
                </Modal.Footer>
            </Modal>

            {/* DataTable */}
            <div className="card border-0 shadow-sm bg-white">
                <div className="card-body p-0">
                    <DataTableBase 
                        data={props.profils.map(profil => {
                            profil.createdAt = new Date(profil.createdAt);
                            profil.roles = profil.roleProfil?.map(prof => prof.role?.nameFr).toString();
                            return profil;
                        })}
                        emptyMessage="Aucun profil trouvé" 
                        filters={filters}
                        globalFiltersFields={['code', 'nameFr', 'roleProfil.role.nameFr', 'createdAt']}
                        header={renderHeader()}
                        columns={setColumns()}
                        exportColumns={[
                            { title: 'Code', dataKey: 'code' },
                            { title: t('common.name'), dataKey: 'nameFr' },
                            { title: 'Roles', dataKey: 'roles' },
                            { title: t('common.create-date'), dataKey: 'createdAt' },
                        ]}
                        rows={10} 
                        showExport={true}
                        exportFilename={"profils"}
                        loading={props.showLoading}
                    />
                </div>
            </div>

            {/* Custom CSS */}
            <style jsx>{`
                .provider-type-header {
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    color: white;
                    border-radius: 8px 8px 0 0;
                }
                
                .provider-type-header h4 {
                    color: white;
                    font-weight: 600;
                }
                
                .provider-type-header p {
                    color: rgba(255, 255, 255, 0.8);
                }
                
                .provider-type-header .btn-outline-primary {
                    border-color: rgba(255, 255, 255, 0.5);
                    color: white;
                }
                
                .provider-type-header .btn-outline-primary:hover {
                    background-color: rgba(255, 255, 255, 0.1);
                    border-color: white;
                }
                
                .provider-type-header .btn-primary {
                    background-color: rgba(255, 255, 255, 0.2);
                    border-color: rgba(255, 255, 255, 0.3);
                    color: white;
                }
                
                .provider-type-header .btn-primary:hover {
                    background-color: rgba(255, 255, 255, 0.3);
                    border-color: rgba(255, 255, 255, 0.5);
                }
                
                /* Button improvements */
                .btn-sm {
                    padding: 0.25rem 0.5rem;
                    font-size: 0.875rem;
                    border-radius: 0.25rem;
                    transition: all 0.2s ease;
                }
                
                .btn-outline-primary:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 2px 4px rgba(0,123,255,0.2);
                }
                
                .btn-outline-danger:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 2px 4px rgba(220,53,69,0.2);
                }
                
                /* Form validation styling */
                .is-invalid {
                    border-color: #dc3545;
                }
                
                .invalid-feedback {
                    display: block;
                    width: 100%;
                    margin-top: 0.25rem;
                    font-size: 0.875em;
                    color: #dc3545;
                }
                
                /* Tag improvements */
                .p-tag {
                    border-radius: 12px;
                    font-size: 0.75rem;
                    font-weight: 500;
                }
                
                /* Responsive design */
                @media (max-width: 768px) {
                    .provider-type-header {
                        flex-direction: column;
                        gap: 1rem;
                    }
                    
                    .provider-type-header .d-flex {
                        flex-direction: column;
                        width: 100%;
                    }
                }
            `}</style>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        rolesData: state.user.roleDatas,
        profils: state.user.profils,
        errorMessage: state.user.errorMessage,
        successMessage: state.user.successMessage,
        showLoading: state.user.showLoading,
        saveDone: state.user.saveDone,
        deleteDone: state.user.deleteDone,
        currentUser: currentUser(state)
    };
};

export default connect(mapStateToProps)(Profil);